import React from "react";
import { NoDataImage } from "../assets/Icons";

const NoDataFound = ({ headText, infoText = null, customCls }) => {
  return (
    <div className={`no-data-found ${customCls ? customCls : ""}`}>
      <NoDataImage />
      <div className="info-here">
        <h6>{headText}</h6>
        {infoText && <p>{infoText} </p>}
      </div>
    </div>
  );
};

export default NoDataFound;
